// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
  resize: none;
}

.recordarea {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner .recordbg {
  height: 500px;
  object-fit: cover;
}

@media (max-width: 1200px) {
  .recordarea textarea {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/member/styles/record.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;;AACA;EACI,aAAA;EACA,iBAAA;AAEJ;;AAAA;EAEQ;IACI,WAAA;EAEV;AACF","sourcesContent":["textarea {\r\n    resize: none;\r\n}\r\n\r\n.recordarea{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n.banner .recordbg {\r\n    height: 500px;\r\n    object-fit: cover;\r\n}\r\n@media (max-width:1200px) {\r\n    .recordarea{\r\n        textarea{\r\n            width: 100%;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
